import React from 'react';
import classNames from 'classnames';
import qs from 'query-string';
import { Link } from 'react-router-dom';
import './styles.scss';
const HITS_PER_PAGE = 10;

const createPageArray = (from, to, currentLocation) => {
    const arr = [];
    const query = qs.parse(currentLocation);
    
    for (var i = from; i <= to; i++) {
        query.page = i;
        arr.push({
            url: `?${qs.stringify(query)}`,
            number: i
        });
    }

    return arr;
}

const Paginate = ({ search, location }) => {
    if (!search.data) return null;

    const query = qs.parse(location.search);
    const currentPage = isNaN(parseInt(query.page)) ? 1 : parseInt(query.page);
    
    const totalPages = Math.ceil(search.totalCount / HITS_PER_PAGE);
    let pages = [];

    if (totalPages > 7) {
        query.page = 1
        pages = [{ url: `?${qs.stringify(query)}`, number: 1 }, { number: '...'}, ...createPageArray(currentPage-1, currentPage+1, location.search), { number: '...'}, { url: `?${qs.stringify({
            ...query,
            page: totalPages
        })}`, number: totalPages }];

        if (currentPage < 5) {
            query.page = totalPages;
            pages = [...createPageArray(1, 5, location.search), { number: '...'}, { url: `?${qs.stringify(query)}`, number: totalPages }];            
        }

        if (currentPage > totalPages-4) {
            query.page = 1
            pages = [{ url: `?${qs.stringify(query)}`, number: 1 }, { number: '...'}, ...createPageArray(totalPages-4, totalPages, location.search)];            
        }
    } else {
        pages = [...createPageArray(1, totalPages, location.search)];
    }

    let ofTotalSearchText = search.totalCount;
    if (search.totalCount > 1000) {
        ofTotalSearchText = `över ${Math.floor(search.totalCount / 1000) * 1000}`; 
    }
    
    query.page = currentPage-1;
    const prevLink = qs.stringify(query);
    query.page = currentPage+1;
    const nextLink = qs.stringify(query);

    return (
        <div className="paginate">
            {totalPages > 1  &&
                <ul className="paginate__pages">
                    {currentPage !== 1 &&
                        <li>
                            <Link className="paginate__nav paginate__nav--prev" to={`?${prevLink}`}></Link>
                        </li>
                    }

                    {pages.map((page, i) => {
                        return (
                            <li key={`page${i}`}>
                                {page.url &&
                                    <Link className={classNames({
                                        'paginate__page': true,
                                        'paginate__page--is-selected': page.number === currentPage,
                                    })} to={page.url}>{page.number}</Link>
                                }
                                {!page.url &&
                                    <>
                                        {page.number}
                                    </>
                                }
                            </li>
                        );
                    })}

                    {currentPage !== totalPages &&
                        <li>
                            <Link className="paginate__nav paginate__nav--next" to={`?${nextLink}`}></Link>
                        </li>
                    }
                </ul>
            }
            <p className="paginate__text">{((currentPage-1)*10) + 1} - {currentPage*10 > search.totalCount ? search.totalCount : currentPage*10} av {ofTotalSearchText} enheter</p>
        </div>   
    );
};

export default Paginate;